import { TabInfoBase } from 'app/buffer-graph/models/tab-info-base';
import { ItemOrderHistory } from 'app/buffer-graph/models/item-order-history/item-order-history';
import { ItemOrderHistoryFresh } from 'app/buffer-graph/models/item-order-history/item-order-history-fresh';
import {ColumnSettingsBase} from "../../../slick-grid/models/column-settings-base";
import {ItemInfo} from "../item-info";
import {Moment} from "moment";

type History = ItemOrderHistory | ItemOrderHistoryFresh;
type Data = { isFresh: boolean, sku: string, warehouseCode: string, orders: History[], canSend: boolean, columns: ColumnSettingsBase[], isAll?: boolean };

export class ItemOrderHistoryTabInfo extends TabInfoBase<Data> {
    constructor(type: string, data: Data, itemInfo: ItemInfo, startDate: Moment, endDate: Moment, sharedGuid: string) {
        super('ItemOrderHistory', type, data, itemInfo, startDate, endDate, sharedGuid);
    }

    get id(): string {
        return ItemOrderHistoryTabInfo.id;
    }

    static readonly id = 'IOH';
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-order-history/item-order-history-tab-info.ts